////////////////////////////////////////////////////////////
//     							                          //
//  Program: Timer.jsx                                    //
//  Application: commpon                                  //
//  Option: For countdown timer into project              //
//  Developer: NP  						                   //
//  Date: 2021-03-09                                      //
//                                                        //
////////////////////////////////////////////////////////////
import React, { Component } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookMessengerShareButton,
} from "react-share";
import {
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailIcon,
  FacebookMessengerIcon,
} from "react-share";
import { Toast } from "react-bootstrap";
import MetaSEO from "../../../MetaSEO";

class SocialShareLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start: Date.now(),
      url: "",
      display: false,
      unitName: this.props.unitName,
      unitImage: this.props.unitImage,
      urlName: this.props.urlName,
      property_slug: this.props.propertySlug
        ? this.props.propertySlug
        : global.property_slug,
      unit_slug: localStorage.getItem("listing_slug")
        ? localStorage.getItem("listing_slug")
        : "",
      showCopyToast: false,
      copyToastMessage: "Copied",
    };
    this.handleCopyLink = this.handleCopyLink.bind(this);
  }

  componentDidMount() {
    window.clearInterval(this.timerCount);
    // this.timerCount = setInterval(() => {
    //   this.timer();
    // }, 1000);
  }
  componentWillUnmount() {
    window.clearInterval(this.timerCount);
  }

  async handleCopyLink(text) {
    let success = false;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        success = true;
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.setAttribute("readonly", "");
        textArea.style.position = "absolute";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.select();
        success = document.execCommand("copy");
        document.body.removeChild(textArea);
      }
    } catch (err) {
      success = false;
    }

    this.setState({
      showCopyToast: true,
      copyToastMessage: success ? "Copied" : "Copy failed",
    });
  }

  render() {
    // const url = global.themeUrl + this.state.property_slug + "/rooms/" + this.state.unit_slug;
    const shareUrl =
      this.state.urlName || this.props.url || window.location.href;
    const shareText =
      this.props.shareText ||
      `Please visit ${this.state.unitName || "this listing"}`;
    const shareHashtags =
      this.props.shareHashtags ||
      (this.state.unitName ? [this.state.unitName] : []);
    const shareMessage = `${shareText}\n${shareUrl}`;
    const smsLink = `sms:?&body=${encodeURIComponent(shareMessage)}`;
    return (
      <>
        <MetaSEO
          title={this.props.title}
          favicon={this.props.favicon}
          keywords={this.props.keywords}
          description={this.props.description}
          noIndex={"true"}
          url={this.props.url}
          image={this.props.image}
          fb_app_id={this.props.fb_app_id}
          og_type="article"
        />
        <div className="mt-0">
          <div className="social-link-div-1">
            <figure>
              <img
                src={this.state.unitImage}
                alt={this.state.unitName}
                className="social-link-img"
                title={this.state.unitName}
              />
            </figure>
            <div className="social-link-heading">{this.state.unitName}</div>
          </div>
          <section className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
              <EmailShareButton
                title={this.state.unitName}
                subject={this.state.unitName}
                body={`${shareText}\n${shareUrl}`}
                url={shareUrl}
                hashtags={["hashtag1", "hashtag2"]}
                className="social-link-buttons"
              >
                <EmailIcon size={32} round className="w-100" />
                Email
              </EmailShareButton>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <WhatsappShareButton
                title={shareText}
                url={shareUrl}
                separator=" - "
                className="social-link-buttons"
              >
                <WhatsappIcon size={32} round className="w-100" />
                What's App
              </WhatsappShareButton>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FacebookMessengerShareButton
                url={shareUrl}
                appId={this.props.fb_app_id}
                redirectUri={shareUrl}
                // quote={"hello this is facebook quote"}
                // hashtag={"#hashtag"}
                // description={"lorem ipsom, eed adsgujbv"}
                className="social-link-buttons"
              >
                <FacebookMessengerIcon size={32} round className="w-100" />
                Messenger
              </FacebookMessengerShareButton>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FacebookShareButton
                url={shareUrl}
                quote={shareText}
                // hashtag={"#hashtag"}
                // description={"lorem ipsom, eed adsgujbv"}
                className="social-link-buttons"
              >
                <FacebookIcon size={32} round className="w-100" />
                Facebook
              </FacebookShareButton>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <TwitterShareButton
                //title={"twitter icon"}
                url={shareUrl}
                title={shareText}
                hashtags={shareHashtags}
                className="social-link-buttons"
              >
                <TwitterIcon size={32} round className="w-100" />
                Twitter
              </TwitterShareButton>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <a
                className="social-link-buttons social_cust text-decoration-none text-dark"
                href={smsLink}
              >
                <span
                  className="d-inline-flex align-items-center justify-content-center social-link-custom-icon social-link-custom-icon-email"
                  aria-hidden="true"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 5h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9l-5 4v-4H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z"
                      stroke="#ffffff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                SMS
              </a>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <button
                type="button"
                className="social-link-buttons social_cust"
                onClick={() => this.handleCopyLink(shareMessage)}
              >
                <span
                  className="d-inline-flex align-items-center justify-content-center social-link-custom-icon social-link-custom-icon-email"
                  aria-hidden="true"
                >
                  {/* <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 9V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-4"
                      stroke="#ffffff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="5"
                      y="9"
                      width="10"
                      height="10"
                      rx="2"
                      stroke="#ffffff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg> */}
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M43.0061 64H9.99388C8.93463 64 7.91878 63.4969 7.16978 62.6015C6.42078 61.7061 6 60.4916 6 59.2252V15.7748C6 14.5084 6.42078 13.2939 7.16978 12.3985C7.91878 11.5031 8.93463 11 9.99388 11H43.0061C44.0654 11 45.0812 11.5031 45.8302 12.3985C46.5792 13.2939 47 14.5084 47 15.7748V59.2252C47 60.4916 46.5792 61.7061 45.8302 62.6015C45.0812 63.4969 44.0654 64 43.0061 64ZM9.99388 13.7284C9.53992 13.7284 9.10455 13.944 8.78355 14.3278C8.46255 14.7116 8.28222 15.2321 8.28222 15.7748V59.2252C8.28222 59.7679 8.46255 60.2884 8.78355 60.6722C9.10455 61.056 9.53992 61.2716 9.99388 61.2716H43.0061C43.4601 61.2716 43.8954 61.056 44.2164 60.6722C44.5374 60.2884 44.7178 59.7679 44.7178 59.2252V15.7748C44.7178 15.2321 44.5374 14.7116 44.2164 14.3278C43.8954 13.944 43.4601 13.7284 43.0061 13.7284H9.99388Z"
                      fill="white"
                    />
                    <path
                      d="M52.9997 53H51.6725V50.2716H52.9997C53.7612 50.205 54.47 49.7872 54.9731 49.1083C55.4762 48.4293 55.7333 47.5438 55.6888 46.6427V6.35727C55.7333 5.45624 55.4762 4.57066 54.9731 3.89172C54.47 3.21279 53.7612 2.79496 52.9997 2.72844H22.0003C21.2388 2.79496 20.53 3.21279 20.0269 3.89172C19.5238 4.57066 19.2667 5.45624 19.3112 6.35727V7.91248H17.003V6.35727C16.9562 4.73208 17.4556 3.15108 18.392 1.95982C19.3284 0.76857 20.6257 0.0639589 22.0003 0H52.9997C54.3743 0.0639589 55.6716 0.76857 56.608 1.95982C57.5444 3.15108 58.0438 4.73208 57.997 6.35727V46.6427C58.0438 48.2679 57.5444 49.8489 56.608 51.0402C55.6716 52.2314 54.3743 52.936 52.9997 53Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Copy Link
              </button>
            </div>
          </section>
          <div
            style={{ position: "fixed", right: 20, bottom: 20, zIndex: 9999 }}
          >
            <Toast
              show={this.state.showCopyToast}
              onClose={() => this.setState({ showCopyToast: false })}
              delay={2000}
              autohide
            >
              <Toast.Body>{this.state.copyToastMessage}</Toast.Body>
            </Toast>
          </div>
        </div>
      </>
    );
  }
}

export default SocialShareLink;
